import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import { Framework } from "vuetify/types";
import ru from "vuetify/es5/locale/ru";

Vue.use(Vuetify);

const Plugin = new Vuetify({
  lang: {
    locales: { ru },
    current: "ru",
  },
  icons: {
    iconfont: "md",
  },
  theme: {
    disabled: true,
  },
});

export const vuetify: Framework = Plugin.framework;

export default Plugin;
